import { faCheck, faCircle, faWarning } from "@fortawesome/pro-solid-svg-icons"
import theme from "css/theme/light"
import { workorderPrimaryStatusColor } from "helpers/WorkOrder/WorkOrderStatusColor"
import { workorderStatusIcon } from "helpers/WorkOrder/WorkOrderStatusIcon"
import { workorderStatusLabel } from "helpers/WorkOrder/WorkOrderStatusLabel"
import { checkLightStatusColor, checksMainStatusColor, VehicleCheckStatus } from "helpers/Checks/ChecksStatusColor"
import { checkStatusIcon } from "helpers/Checks/CheckStatusIcon"
import { t } from "i18next"

export const eventIcon = (status: any) => {
  switch (status) {
    case "approved":
      return faCheck
    case "error":
      return faWarning
    default:
      return faCircle
  }
}

export const eventColor = (status: any) => {
  switch (status) {
    case "approved":
      return theme.palette.success.dark
    case "error":
      return theme.palette.error.dark
    default:
      return theme.palette.primary.light
  }
}

export const eventStatusLabel = (status: number) => {
  switch (status) {
    case 2:
      return t("global.approved", "Approved")
    case 3:
      return t("global.critical", "Critical")
    default:
      return t("global.missing_status", "Missing status")
  }
}

const checksStatusLabel = (status: VehicleCheckStatus) => {
  switch (status) {
    case VehicleCheckStatus.Booked:
      return t("global.booked", "Booked")
    case VehicleCheckStatus.Upcoming:
      return t("global.need_to_book", "Need to book")
    case VehicleCheckStatus.Late:
      return t("vehicleregistry.driving_ban", "Driving ban")
    case VehicleCheckStatus.Passed:
      return t("global.approved", "Approved")
    case VehicleCheckStatus.Failed:
      return t("global.failed", "Failed")
    case VehicleCheckStatus.Waiting:
      return t("global.awaiting_result", "Awaiting result")
    default:
      return "-"
  }
}

export const statusLabel = (typeId: string | undefined, status: number, typeIdInLabel?: boolean, t?: any) => {
  switch (typeId) {
    case "Arbetsorder":
      return `${typeIdInLabel ? typeId + ": " : ""} ${workorderStatusLabel(status, t)}`
    case "Besiktning":
    case "Service":
      return `${typeIdInLabel ? typeId + ": " : ""} ${checksStatusLabel(status)}`
    default:
      return eventStatusLabel(status)
  }
}

export const statusIcon = (typeId?: string, status?: number) => {
  switch (typeId) {
    case "Arbetsorder":
      return workorderStatusIcon(status ? status : 0)
    case "Besiktning":
    case "Service":
      return checkStatusIcon(status ? status : 0)
    default:
      return eventIcon(status)
  }
}

export const statusColor = (typeId?: string, status?: any) => {
  switch (typeId) {
    case "Arbetsorder":
      return workorderPrimaryStatusColor(status)
    case "Besiktning":
    case "Service":
      return checksMainStatusColor(status)
    default:
      return eventColor(status)
  }
}

export const statusIconColor = (typeId?: string, status?: any) => {
  switch (typeId) {
    case "Arbetsorder":
      return workorderPrimaryStatusColor(status)
    case "Besiktning":
    case "Service":
      return checksMainStatusColor(status)
    default:
      return theme.palette.primary.main
  }
}

export function backgroundStatusColor(typeId: string | null | undefined, status: any) {
  switch (typeId) {
    case "Besiktning":
    case "Service":
      return checkLightStatusColor(status)
    default:
      return eventColor(status)
  }
}
